import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from 'i18next-xhr-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import {env} from '../../config/apiConfig';


let lang;
const detectionOptions = {
    order: ['path', 'cookie', 'navigator', 'localStorage', 'subdomain', 'queryString', 'htmlTag'],
    lookupFromPathIndex: 0
}

i18n
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
        debug: false,
        detection: detectionOptions,
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false // react already safes from xss
        },
        backend: {
            loadPath: '/translations/{{lng}}/{{ns}}.json'
        },
    })
    .then(()=> {
        let i18nLanguage = i18n.language.toLowerCase();
        const map = new Map ([["ar", "ar-XB"],["en-xa" , "en-XA"], ["en-xc", "en-XC"], ["fr-ca", "fr-CA"], ["pt-pt" , "pt-PT"], ["sr-latn" , "sr-Latn"], ["zh-hans","zh-Hans"], ["zh-hant","zh-Hant"], ["zh", "zh-Hans"]]);
        if (map.has(i18nLanguage)) {
             lang = map.get(i18nLanguage);
        } else if (map.has(i18nLanguage.substring(0,2))) {
            lang = map.get(i18nLanguage.substring(0,2));
        } else {
            lang = i18nLanguage.substring(0,2);
        }
        i18n.changeLanguage(lang);
    });

export default i18n;